export default {
  container: {
    xl: '1440px',
    md: '740px',
  },
}
